import React from 'react'
import DocumentHeaderBG from '../../../../../components/Icons/DocumentHeaderBG'
import DocumentPill from './DocumentPill'

const DocumentCardHeader = ({ documentStatus }) => (
  <div className="w-1/2 relative">
    <DocumentHeaderBG height="35" className="-z-10" />
    <DocumentPill documentStatus={documentStatus} />
  </div>
)
export default React.memo(DocumentCardHeader)
